// components
import CommonActionModal from "../../Common/CommonActionModal";
import CommonForm from "../../Common/CommonForm";
import BaseApi from "../../../utils/BaseApi";
import {splitToList} from "../../../utils/misc";

// icons
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";


class UltimateAdminEditModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: EditIcon,
            buttonColor: 'neutral',
            modalLabel: 'Редактирование ' + this.props.model,
            modalIcon: AssignmentIcon,
            ready: true,
        })
    }

    beforeModalOpen() {
        let obj = this.props.componentObj;
        for (let field of this.props.formFields){
            if (field.type === 'file'){
                obj[field.name] = null
            }
        }
        return(
            {
                mainComponent: CommonForm,
                mainComponentProps: {
                    fields: this.props.formFields,
                    processForm: this.processForm.bind(this),
                    object: obj,
                },
            }
        )
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        const url = `admin/${this.props.componentObj.id}/?model=${this.props.model}`;
        const api = new BaseApi();
        let uploadFormData = new FormData()
        for (let field of this.props.formFields){
            switch (field.type){
                case 'multiselect':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = splitToList(formDataObj[field.name], ',')
                    }
                    break
                case 'file':
                    delete formDataObj[field.name]
                    let fileInput = form.state.formObject[field.name];
                    let upload = fileInput.files[0];
                    if (upload) {
                        uploadFormData.append(field.name, upload);
                    }
                    break
                case 'json':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = JSON.parse(formDataObj[field.name])
                    }
                    break
                default:
                    break
            }
        }
        let response = await api.patch(
            url,
            formDataObj
        );
        if (response.status === 200) {
            let _response = await api.patch(
                url,
                uploadFormData
            );
            if (_response.status === 200) {
                if (this.props.callBack){
                    await this.props.callBack()
                }
                this.setModalOpenFalse();
            }
        }
        return response
    }
}

export default UltimateAdminEditModal